import {useCountryList} from '@/context/CountryListContext';
import type {AfriexCountry} from '@/types';
import {mapCountryCodeToFlags} from '@/utils/countries';

type SummaryProp = {
  item: AfriexCountry;
};

const Summary = ({item}: SummaryProp) => {
  const {state: countryListState} = useCountryList();
  const {countryList} = countryListState;
  return (
    <div className="flex flex-col gap-3 mt-4">
      <h3 className="text-sm font-semibold text-gray-600 dark:text-gray-200">
        {item?.name} Details
      </h3>
      <div className="overflow-x-auto">
        <div className="mb-2 py-2 px-3 flex items-center gap-3 bg-gray-100 dark:bg-gray-900 justify-between">
          <p className="text-slate-500 text-sm dark:text-slate-100">Name</p>
          <p className="text-sm font-medium text-gray-700 w-1/2 dark:text-gray-100">
            {item?.name}
          </p>
        </div>
        <div className="mb-2 py-2 px-3 flex items-center gap-3 bg-gray-100 dark:bg-gray-900 justify-between">
          <p className="text-slate-500 text-sm dark:text-slate-100">Code</p>
          <p className="text-sm font-medium text-gray-700 w-1/2 dark:text-gray-100">
            {item?.iso2}{' '}
            {item?.flag ?? mapCountryCodeToFlags(countryList)[item?.iso2]}
          </p>
        </div>
        <div className="mb-2 py-2 px-3 flex items-center gap-3 bg-gray-100 dark:bg-gray-900 justify-between">
          <p className="text-slate-500 text-sm dark:text-slate-100">Currency</p>
          <p className="text-sm font-medium text-gray-700 w-1/2 dark:text-gray-100">
            {item?.currency}
          </p>
        </div>
        <div className="mb-2 py-2 px-3 flex items-center gap-3 bg-gray-100 dark:bg-gray-900 justify-between">
          <p className="text-slate-500 text-sm dark:text-slate-100">Status</p>
          <p className="text-sm font-medium text-gray-700 w-1/2 dark:text-gray-100">
            {item?.status?.toString()}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Summary;
